/* Cotton purchases — the bills register, in the shape the Purchases page
 * draws: the design's `window.COTTON_PURCHASES`, one row per bill line. */

import { request } from './api'

export interface PurchaseRow {
  /** Received date, ISO. */
  d: string
  /** The bill sheet's month, YYYY-MM. */
  mk: string
  sup: string
  type: 'CCI' | 'Private' | 'Group'
  st: string
  agent: string
  inv: string
  lot: string
  bales: number
  kg: number
  /** Contract ₹/candy; null where the sheet has none. */
  candy: number | null
  /** Taxable value, ex-GST, incl. CCI charges. */
  taxable: number
  gst: number
  invVal: number
  /** Freight, 0 where none is recorded. */
  fr: number
  /** Mill weight − party weight, kg; null without a weighbridge figure. */
  diff: number | null
  party: number | null
  trading: boolean
}

export interface Purchases { source: string | null; fy: string; rows: PurchaseRow[] }

export const purchases = {
  rows: () => request<Purchases>('/purchases/rows'),
  /** Replaces every bill month the workbook carries. */
  upload: async (file: File) => {
    const fd = new FormData()
    fd.append('file', file)
    return request<{
      ok: boolean; source: string; rows: number; rows_replaced: number
      months: string[]; warnings: string[]
    }>('/purchases/upload', { method: 'POST', body: fd })
  },
}
